<template>
    <div class="main">
        <div>
            <div
                id="container"
                class="mymap"
                style="width: 100%; height: 100%"
            ></div>
            <div class="superLeft">
                <div class="oldBox superBox">
                    <div class="leftTitle">养老机构统计</div>
                    <!-- 床位数 -->
                    <div id="beds"></div>
                    <div class="borderLine"></div>
                    <!-- 机构评级覆盖率 -->
                    <div id="mechanism"></div>
                    <div class="borderLine"></div>
                    <!-- 医养结合覆盖率 -->
                    <div id="combination"></div>
                </div>
            </div>
            <div class="superRight">
                <div class="rightBox">
                    <div class="rightChart">
                        <div class="oldBox jgBox">
                            <div class="leftTitle">
                                养老机构入住率<span style="font-size: 16px"
                                    >(45%)</span
                                >
                            </div>
                            <p class="chartTitles"></p>
                            <div class="chartBox">
                                <div class="chartItem">
                                    <div class="wave-progress wave-progress1">
                                        <div id="num" class="num"></div>
                                        <div class="wave wave1"></div>
                                        <div
                                            id="wave-mask"
                                            class="wave-mask"
                                        ></div>
                                    </div>
                                    <p class="waveNum">
                                        {{ occupancyElderlyNum0 }}
                                    </p>
                                    <p class="waveTitle waveTitle1">
                                        <!-- {{ mechanism0 }} -->
                                        新安镇
                                    </p>
                                </div>
                                <div class="chartItem">
                                    <div class="wave-progress wave-progress2">
                                        <div id="num1" class="num"></div>
                                        <div class="wave wave2"></div>
                                        <div
                                            id="wave-mask1"
                                            class="wave-mask"
                                        ></div>
                                    </div>
                                    <p class="waveNum">
                                        {{ occupancyElderlyNum1 }}
                                    </p>
                                    <p class="waveTitle waveTitle2">
                                        <!-- {{ mechanism1 }} -->
                                        半塔镇
                                    </p>
                                </div>
                                <div class="chartItem">
                                    <div class="wave-progress wave-progress3">
                                        <div id="num2" class="num"></div>
                                        <div class="wave wave3"></div>
                                        <div
                                            id="wave-mask2"
                                            class="wave-mask"
                                        ></div>
                                    </div>
                                    <p class="waveNum">
                                        {{ occupancyElderlyNum2 }}
                                    </p>
                                    <p class="waveTitle waveTitle3">
                                        <!-- {{ mechanism2 }} -->
                                        水口镇
                                    </p>
                                </div>
                                <div class="chartItem">
                                    <div class="wave-progress wave-progress4">
                                        <div id="num3" class="num"></div>
                                        <div class="wave wave4"></div>
                                        <div
                                            id="wave-mask3"
                                            class="wave-mask"
                                        ></div>
                                    </div>
                                    <p class="waveNum">
                                        {{ occupancyElderlyNum3 }}
                                    </p>
                                    <p class="waveTitle waveTitle4">
                                        <!-- {{ mechanism3 }} -->
                                        汊河镇
                                    </p>
                                </div>
                                <div class="chartItem">
                                    <div class="wave-progress wave-progress4">
                                        <div id="num4" class="num"></div>
                                        <div class="wave wave1"></div>
                                        <div
                                            id="wave-mask4"
                                            class="wave-mask"
                                        ></div>
                                    </div>
                                    <p class="waveNum">
                                        {{ occupancyElderlyNum4 }}
                                    </p>
                                    <p class="waveTitle waveTitle1">
                                        <!-- {{ mechanism3 }} -->
                                        大英镇
                                    </p>
                                </div>
                                <div class="chartItem">
                                    <div class="wave-progress wave-progress4">
                                        <div id="num5" class="num"></div>
                                        <div class="wave wave2"></div>
                                        <div
                                            id="wave-mask5"
                                            class="wave-mask"
                                        ></div>
                                    </div>
                                    <p class="waveNum">
                                        {{ occupancyElderlyNum5 }}
                                    </p>
                                    <p class="waveTitle waveTitle2">
                                        <!-- {{ mechanism3 }} -->
                                        雷官镇
                                    </p>
                                </div>
                                <div class="chartItem">
                                    <div class="wave-progress wave-progress4">
                                        <div id="num6" class="num"></div>
                                        <div class="wave wave3"></div>
                                        <div
                                            id="wave-mask6"
                                            class="wave-mask"
                                        ></div>
                                    </div>
                                    <p class="waveNum">
                                        {{ occupancyElderlyNum6 }}
                                    </p>
                                    <p class="waveTitle waveTitle3">
                                        <!-- {{ mechanism3 }} -->
                                        施官镇
                                    </p>
                                </div>
                                <div class="chartItem">
                                    <div class="wave-progress wave-progress4">
                                        <div id="num7" class="num"></div>
                                        <div class="wave wave4"></div>
                                        <div
                                            id="wave-mask7"
                                            class="wave-mask"
                                        ></div>
                                    </div>
                                    <p class="waveNum">
                                        {{ occupancyElderlyNum7 }}
                                    </p>
                                    <p class="waveTitle waveTitle4">
                                        <!-- {{ mechanism3 }} -->
                                        舜山镇
                                    </p>
                                </div>
                                <div class="chartItem">
                                    <div class="wave-progress wave-progress4">
                                        <div id="num8" class="num"></div>
                                        <div class="wave wave1"></div>
                                        <div
                                            id="wave-mask8"
                                            class="wave-mask"
                                        ></div>
                                    </div>
                                    <p class="waveNum">
                                        {{ occupancyElderlyNum8 }}
                                    </p>
                                    <p class="waveTitle waveTitle1">
                                        <!-- {{ mechanism3 }} -->
                                        三城乡
                                    </p>
                                </div>
                                <div class="chartItem">
                                    <div class="wave-progress wave-progress4">
                                        <div id="num9" class="num"></div>
                                        <div class="wave wave2"></div>
                                        <div
                                            id="wave-mask9"
                                            class="wave-mask"
                                        ></div>
                                    </div>
                                    <p class="waveNum">
                                        {{ occupancyElderlyNum9 }}
                                    </p>
                                    <p class="waveTitle waveTitle2">
                                        <!-- {{ mechanism3 }} -->
                                        独山乡
                                    </p>
                                </div>
                                <div class="chartItem">
                                    <div class="wave-progress wave-progress4">
                                        <div id="num10" class="num"></div>
                                        <div class="wave wave3"></div>
                                        <div
                                            id="wave-mask10"
                                            class="wave-mask"
                                        ></div>
                                    </div>
                                    <p class="waveNum">
                                        {{ occupancyElderlyNum10 }}
                                    </p>
                                    <p class="waveTitle waveTitle3">
                                        <!-- {{ mechanism3 }} -->
                                        张山乡
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="oldBox rzBox heBox">
                            <div class="leftTitle">入住能力评估</div>
                            <div id="huli"></div>
                            <div id="lodLiveEcharts" ref="lodLiveEcharts"></div>
                        </div>
                    </div>
                    <div class="rightTable">
                        <div class="mechanismNum">
                            <div class="mechanismItem">
                                <p class="name">养老机构</p>
                                <p class="nums">
                                    <img
                                        src="./assets/big/jigou2.png"
                                        class="imgs"
                                        alt=""
                                        srcset=""
                                    /><span>13</span>家
                                </p>
                            </div>
                            <div class="mechanismItem">
                                <p class="name">总床位数</p>
                                <p class="nums">
                                    <img
                                        src="./assets/big/jigou1.png"
                                        class="imgs"
                                        alt=""
                                        srcset=""
                                    /><span> 994 </span>张
                                </p>
                            </div>
                            <div class="mechanismItem2">
                                <p class="name">养老机构护理型床位占比</p>
                                <p class="nums">
                                    <img
                                        src="./assets/big/jigou3.png"
                                        class="imgs"
                                        alt=""
                                        srcset=""
                                    /><span>
                                        <!-- 80% -->
                                        45%
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div class="oldBox rzBoxs">
                            <div class="leftTitle">入住老人信息</div>
                            <div class="houseBox">
                                <div
                                    class="houseList"
                                    v-if="tableList.length > 0"
                                >
                                    <div class="houseBar">
                                        <p class="names">姓名</p>
                                        <!-- <p class="ages">年龄</p> -->
                                        <p class="sex">性别</p>
                                        <!-- <p class="times">身体状况</p> -->
                                        <p class="level">失能等级</p>
                                        <p class="mechanisms">地址</p>
                                    </div>
                                    <div
                                        class="houseContent"
                                        style="height: 620px; overflow: scroll"
                                        @click="showInfo($event)"
                                    >
                                        <vue-seamless-scroll
                                            :style="{
                                                height:
                                                    this.scrollHeight + 'px',
                                            }"
                                            :data="tableList"
                                            :class-option="defaultOption"
                                            class="warp-content"
                                        >
                                            <div
                                                class="houseItem"
                                                v-for="(
                                                    item, index
                                                ) in tableList"
                                                :key="index"
                                            >
                                                <p
                                                    class="names"
                                                    :data-obj="
                                                        JSON.stringify(item)
                                                    "
                                                >
                                                    {{ item.customerName }}
                                                </p>
                                                <!-- <p class="ages" :data-obj="JSON.stringify(item)">
                          {{ item.age }}
                        </p> -->
                                                <p
                                                    class="sex"
                                                    :data-obj="
                                                        JSON.stringify(item)
                                                    "
                                                >
                                                    {{ item.gender }}
                                                </p>
                                                <!-- <p class="times" :data-obj="JSON.stringify(item)">
                            {{ item.conditional }}
                          </p> -->
                                                <p
                                                    class="level"
                                                    :data-obj="
                                                        JSON.stringify(item)
                                                    "
                                                >
                                                    <span
                                                        :data-obj="
                                                            JSON.stringify(item)
                                                        "
                                                        v-if="
                                                            item.selfCare ==
                                                            '自理'
                                                        "
                                                        class="color2"
                                                        >自理</span
                                                    >
                                                    <span
                                                        :data-obj="
                                                            JSON.stringify(item)
                                                        "
                                                        v-if="
                                                            item.selfCare ==
                                                            '半自理'
                                                        "
                                                        class="color1"
                                                        >半自理</span
                                                    >
                                                    <span
                                                        :data-obj="
                                                            JSON.stringify(item)
                                                        "
                                                        v-if="
                                                            item.selfCare ==
                                                            '不能自理'
                                                        "
                                                        class="color3"
                                                        >不能自理</span
                                                    >
                                                    <span
                                                        :data-obj="
                                                            JSON.stringify(item)
                                                        "
                                                        v-if="
                                                            item.selfCare ==
                                                            '半失能'
                                                        "
                                                        class="color4"
                                                        >半失能</span
                                                    >
                                                </p>
                                                <p
                                                    class="mechanisms"
                                                    :data-obj="
                                                        JSON.stringify(item)
                                                    "
                                                >
                                                    {{ item.address }}
                                                </p>
                                            </div>
                                        </vue-seamless-scroll>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="oldBox safeBox">
                            <div class="leftTitle">安全检查列表</div>
                            <div class="houseBox">
                                <div
                                    class="houseList"
                                    v-if="insList.length > 0"
                                >
                                    <div class="houseBar flexs">
                                        <p class="names">巡检名称</p>
                                        <p class="ages">设置时限</p>
                                        <!-- <p class="sex">巡检机构</p> -->
                                        <p class="times">巡检人员</p>
                                    </div>
                                    <div
                                        class="houseContent"
                                        style="height: 60vh; overflow: scroll"
                                    >
                                        <vue-seamless-scroll
                                            :style="{
                                                height:
                                                    this.scrollHeight + 'px',
                                            }"
                                            :data="insList"
                                            :class-option="defaultOption"
                                            class="warp-content"
                                        >
                                            <div
                                                class="houseItem flexs"
                                                v-for="(item, index) in insList"
                                                :key="index"
                                            >
                                                <p
                                                    :data-obj="
                                                        JSON.stringify(item)
                                                    "
                                                >
                                                    {{ item.insName }}
                                                </p>
                                                <p
                                                    :data-obj="
                                                        JSON.stringify(item)
                                                    "
                                                >
                                                    {{ item.startTime }}-{{
                                                        item.endTime
                                                    }}
                                                </p>
                                                <!-- <p  :data-obj="JSON.stringify(item)">
                            {{ item.insOrgName }}
                          </p> -->
                                                <p
                                                    :data-obj="
                                                        JSON.stringify(item)
                                                    "
                                                >
                                                    {{ item.insPersonName }}
                                                </p>
                                            </div>
                                        </vue-seamless-scroll>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 机构信息弹窗 -->
            <div class="mechanism_info" v-show="mechanism">
                <div class="mechanismName">{{ info.name }}</div>
                <div
                    class="monitor"
                    @click="dialogervices"
                    v-if="
                        this.info.id == 0 ||
                        this.info.id == 1 ||
                        this.info.id == 4 ||
                        this.info.id == 8 ||
                        this.info.id == 9 
                    "
                >
                    <img src="./assets/imgs/monitor.png" />
                </div>
                <div class="x" @click="close">x</div>
                <div class="content1">
                    <div
                        class="btnGroup"
                        style="display: flex; justify-content: space-between"
                    >
                        <div
                            style="
                                display: flex;
                                margin: 10px 0;
                                font-size: 20px;
                            "
                        >
                            <p class="box" id="box">机构基本信息</p>
                        </div>
                    </div>
                    <el-form
                        style="background: #01117b"
                        label-position="right"
                        label-width="120px"
                        ref="orgsData"
                        :model="info"
                        class=""
                        v-show="step == 0"
                    >
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="机构名称：">
                                    <el-input
                                        v-model="info.name"
                                        disabled
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="机构地址：">
                                    <el-input
                                        v-model="info.address"
                                        disabled
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="创建时间：">
                                    <el-input
                                        v-model="info.build"
                                        disabled
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="联系人：">
                                    <el-input
                                        v-model="info.person"
                                        disabled
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="联系电话：">
                                    <el-input
                                        v-model="info.phone"
                                        disabled
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="建筑面积：">
                                    <el-input
                                        v-model="info.area"
                                        disabled
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="性质：">
                                    <el-input
                                        v-model="info.nature"
                                        disabled
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="房屋性质：">
                                    <el-input
                                        v-model="info.houserNature"
                                        disabled
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
            <!-- 老人信息展示框 -->
            <div class="older-info">
                <el-dialog
                    title="老人信息"
                    :visible.sync="olderInfoVisible"
                    width="35%"
                    style="margin-top: 15vh"
                >
                    <div>
                        <el-form
                            label-position="right"
                            label-width="100px"
                            ref="objList"
                            :model="objList"
                            class="content-info"
                        >
                            <el-form-item
                                class="content-info-item"
                                label="姓名："
                                prop="name"
                            >
                                <el-input
                                    :value="objList.name"
                                    disabled
                                ></el-input>
                            </el-form-item>

                            <el-form-item
                                class="content-info-item"
                                label="年龄："
                                prop="age"
                            >
                                <el-input
                                    :value="objList.age"
                                    disabled
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                class="content-info-item"
                                label="性别："
                                prop="sex"
                            >
                                <!-- <el-input :value="objList.sex" disabled></el-input> -->
                                <el-select
                                    v-model="objList.sex"
                                    disabled
                                    style="width: 100%"
                                >
                                    <el-option value="1" label="男"></el-option>
                                    <el-option value="2" label="女"></el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item
                                class="content-info-item"
                                label="身体状况："
                                prop="conditional"
                            >
                                <el-input
                                    :value="objList.conditional"
                                    disabled
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                class="content-info-item"
                                label="失能等级："
                                prop="assessment"
                            >
                                <el-select
                                    v-model="objList.assessment"
                                    disabled
                                    style="width: 100%"
                                >
                                    <el-option
                                        :value="1"
                                        label="自理"
                                    ></el-option>
                                    <el-option
                                        :value="2"
                                        label="半自理"
                                    ></el-option>
                                    <el-option
                                        :value="3"
                                        label="失能"
                                    ></el-option>
                                    <el-option
                                        :value="4"
                                        label="半失能"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                class="content-info-item"
                                label="所属机构："
                                prop="mechanismCareName"
                            >
                                <el-input
                                    :value="objList.mechanismCareName"
                                    disabled
                                ></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-dialog>
            </div>
            <!-- 巡检信息展示框 -->
            <div class="older-info">
                <el-dialog
                    title="巡检信息"
                    :visible.sync="xunInfoVisible"
                    width="30%"
                    style="margin-top: 35vh"
                >
                    <div>
                        <el-form
                            label-position="center"
                            label-width="100px"
                            ref="xunList"
                            :model="xunList"
                            class=""
                        >
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item
                                        label="巡检名称:"
                                        prop="insName"
                                    >
                                        <el-input
                                            style="width: 96%"
                                            v-model="xunList.insName"
                                            placeholder="请输入巡检名称"
                                            disabled
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="设置时限:">
                                        <el-date-picker
                                            v-model="xunList.startTime"
                                            type="datetime"
                                            placeholder="开始时间"
                                            class="searchTjContentDivInput"
                                            clearable
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            disabled
                                        >
                                        </el-date-picker>
                                        <span
                                            class="searchTjContentDivSpan"
                                            style="padding: 0 20px"
                                            >至</span
                                        >
                                        <el-date-picker
                                            v-model="xunList.endTime"
                                            type="datetime"
                                            placeholder="结束时间"
                                            class="searchTjContentDivInput"
                                            clearable
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            disabled
                                        >
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item
                                        label="巡检机构:"
                                        prop="insOrgName"
                                    >
                                        <el-input
                                            style="width: 96%"
                                            v-model="xunList.insOrgName"
                                            disabled
                                            placeholder="请输入巡检名称"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item
                                        label="巡检人员:"
                                        prop="insPersonName"
                                    >
                                        <el-input
                                            style="width: 96%"
                                            v-model="xunList.insPersonName"
                                            disabled
                                            placeholder="请输入巡检人员"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </el-dialog>
            </div>
        </div>
        <!-- //监控 -->
        <div class="older-info">
            <el-dialog
                title="监控"
                :visible.sync="dialogVisibles"
                width="650px"
                @close="handleCloses"
            >
                <div style="width: 100%" class="" v-if="this.info.id == 0">
                    <iframe
                        allowfullscreen
                        style="
                            width: 600px;
                            height: 350px;
                            position: relative;
                            z-index: 2000;
                            margin-top: 5px;
                        "
                        :src="`https://open.ys7.com/jssdk/theme.html?url=ezopen://open.ys7.com/C01283937/1.live&accessToken=at.984n4der77uot6hv39eugjxtahoafayd-45gl44nrvi-1kn72hr-glywacjrx&id=ysopen`"
                    ></iframe>
                    <iframe
                        allowfullscreen
                        style="
                            width: 600px;
                            height: 350px;
                            position: relative;
                            z-index: 2000;
                            margin-top: 5px;
                        "
                        :src="`https://open.ys7.com/jssdk/theme.html?url=ezopen://open.ys7.com/C01283937/11.live&accessToken=at.984n4der77uot6hv39eugjxtahoafayd-45gl44nrvi-1kn72hr-glywacjrx&id=ysopen`"
                    ></iframe>
                    <iframe
                        allowfullscreen
                        style="
                            width: 600px;
                            height: 350px;
                            position: relative;
                            z-index: 2000;
                        "
                        :src="`https://open.ys7.com/jssdk/theme.html?url=ezopen://open.ys7.com/C01283937/10.live&accessToken=at.afjblkv7cdblec6b1i9uusq9a3v2mx4l-8oilbdii1g-0imeeh9-galmabhqq&id=ysopen`"
                    ></iframe>
                </div>
                <div style="width: 100%" class="" v-if="this.info.id == 1">
                    <iframe
                        allowfullscreen
                        style="
                            width: 600px;
                            height: 350px;
                            position: relative;
                            z-index: 2000;
                            margin-top: 5px;
                        "
                        :src="`https://open.ys7.com/jssdk/theme.html?url=ezopen://open.ys7.com/C90485389/21.live&accessToken=at.984n4der77uot6hv39eugjxtahoafayd-45gl44nrvi-1kn72hr-glywacjrx&id=ysopen`"
                    ></iframe>
                    <iframe
                        allowfullscreen
                        style="
                            width: 600px;
                            height: 350px;
                            position: relative;
                            z-index: 2000;
                            margin-top: 5px;
                        "
                        :src="`https://open.ys7.com/jssdk/theme.html?url=ezopen://open.ys7.com/C90485389/25.live&accessToken=at.984n4der77uot6hv39eugjxtahoafayd-45gl44nrvi-1kn72hr-glywacjrx&id=ysopen`"
                    ></iframe>
                </div>
                <div style="width: 100%" class="" v-if="this.info.id == 4">
                    <iframe
                        allowfullscreen
                        style="
                            width: 600px;
                            height: 350px;
                            position: relative;
                            z-index: 2000;
                            margin-top: 5px;
                        "
                        :src="`https://open.ys7.com/jssdk/theme.html?url=ezopen://open.ys7.com/C87549051/8.live&accessToken=at.984n4der77uot6hv39eugjxtahoafayd-45gl44nrvi-1kn72hr-glywacjrx&id=ysopen`"
                    ></iframe>
                    <iframe
                        allowfullscreen
                        style="
                            width: 600px;
                            height: 350px;
                            position: relative;
                            z-index: 2000;
                            margin-top: 5px;
                        "
                        :src="`https://open.ys7.com/jssdk/theme.html?url=ezopen://open.ys7.com/C87549051/10.live&accessToken=at.984n4der77uot6hv39eugjxtahoafayd-45gl44nrvi-1kn72hr-glywacjrx&id=ysopen`"
                    ></iframe>
                </div>
                <div style="width: 100%" class="" v-if="this.info.id == 8">
                    <iframe
                        allowfullscreen
                        style="
                            width: 600px;
                            height: 350px;
                            position: relative;
                            z-index: 2000;
                            margin-top: 5px;
                        "
                        :src="`https://open.ys7.com/jssdk/theme.html?url=ezopen://open.ys7.com/C08635586/2.live&accessToken=at.984n4der77uot6hv39eugjxtahoafayd-45gl44nrvi-1kn72hr-glywacjrx&id=ysopen`"
                    ></iframe>
                    <iframe
                        allowfullscreen
                        style="
                            width: 600px;
                            height: 350px;
                            position: relative;
                            z-index: 2000;
                            margin-top: 5px;
                        "
                        :src="`https://open.ys7.com/jssdk/theme.html?url=ezopen://open.ys7.com/C08635586/8.live&accessToken=at.984n4der77uot6hv39eugjxtahoafayd-45gl44nrvi-1kn72hr-glywacjrx&id=ysopen`"
                    ></iframe>
                </div>
                <div style="width: 100%" class="" v-if="this.info.id == 9">
                    <iframe
                        allowfullscreen
                        style="
                            width: 600px;
                            height: 350px;
                            position: relative;
                            z-index: 2000;
                            margin-top: 5px;
                        "
                        :src="`https://open.ys7.com/jssdk/theme.html?url=ezopen://open.ys7.com/C59409709/3.live&accessToken=at.984n4der77uot6hv39eugjxtahoafayd-45gl44nrvi-1kn72hr-glywacjrx&id=ysopen`"
                    ></iframe>
                    <iframe
                        allowfullscreen
                        style="
                            width: 600px;
                            height: 350px;
                            position: relative;
                            z-index: 2000;
                            margin-top: 5px;
                        "
                        :src="`https://open.ys7.com/jssdk/theme.html?url=ezopen://open.ys7.com/C59409709/4.live&accessToken=at.984n4der77uot6hv39eugjxtahoafayd-45gl44nrvi-1kn72hr-glywacjrx&id=ysopen`"
                    ></iframe>
                </div>
                <div style="width: 100%" class="" v-if="this.info.id == 11">
                    <iframe
                        allowfullscreen
                        style="
                            width: 600px;
                            height: 350px;
                            position: relative;
                            z-index: 2000;
                            margin-top: 5px;
                        "
                        :src="`https://open.ys7.com/jssdk/theme.html?url=ezopen://open.ys7.com/108664759/10.live&accessToken=at.afjblkv7cdblec6b1i9uusq9a3v2mx4l-8oilbdii1g-0imeeh9-galmabhqq&id=ysopen`"
                    ></iframe>
                    <iframe
                        allowfullscreen
                        style="
                            width: 600px;
                            height: 350px;
                            position: relative;
                            z-index: 2000;
                            margin-top: 5px;
                        "
                        :src="`https://open.ys7.com/jssdk/theme.html?url=ezopen://open.ys7.com/108664759/3.live&accessToken=at.afjblkv7cdblec6b1i9uusq9a3v2mx4l-8oilbdii1g-0imeeh9-galmabhqq&id=ysopen`"
                    ></iframe>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import request from "@/utils/request.js"
export default {
    data() {
        return {
            map: null,
            marker: null,
            markers: [],
            recMarker: null,
            dialogVisibles: false,
            stationList: [
                {
                    id: "0",
                    name: "新安镇敬老院",
                    address: "来安县华阳镇龙川大道柏枝湾",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "程华光",
                    phone: "13856385158",
                    longitude: "118.434581",
                    latitude: "32.428848",
                    build: "1994",
                    area: "占地1100m²，建筑791m²",
                },
                {
                    id: "1",
                    name: "半塔镇敬老院",
                    address: "来安县临溪镇临溪村",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "胡树发",
                    phone: "13635633584",
                    longitude: "118.588275",
                    latitude: "32.675221",
                    build: "2012",
                    area: "占地1200m²，建筑1000m²",
                },
                {
                    id: "2",
                    name: "汊河镇敬老院",
                    address: "来安县长安镇镇头村",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "周顺和",
                    phone: "13329296783",
                    longitude: "118.595726",
                    latitude: "32.206585",
                    build: "1992",
                    area: "占地2500m²，建筑1868m²",
                },
                {
                    id: "3",
                    name: "水口镇敬老院",
                    address: "来安县上庄镇上庄村",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "汪卫国",
                    phone: "13866965240",
                    longitude: "118.497759",
                    latitude: "32.317896",
                    build: "2011",
                    area: "占地3400m²，建筑1600m²",
                },
                {
                    id: "4",
                    name: "舜山镇敬老院",
                    address: "来安县扬溪镇大石门村",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "周玥莉",
                    phone: "15105638033",
                    longitude: "118.441856",
                    latitude: " 32.536382",
                    build: "2012",
                    area: "占地1050m²，建筑975m²",
                },
                {
                    id: "5",
                    name: "雷官镇敬老院",
                    address: "来安县板桥头乡尚田村",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "汪卫忠",
                    phone: "13966223597",
                    longitude: "118.620944",
                    latitude: "32.345538",
                    build: "2008",
                    area: "占地2050m²，建筑1010m²",
                },
                {
                    id: "6",
                    name: "施官镇敬老院",
                    address: "来安县金沙镇金沙村",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "周金虎",
                    phone: "13965401731",
                    longitude: "118.580735",
                    latitude: "32.455542",
                    build: "2010",
                    area: "占地1700m²，建筑628m²",
                },
                {
                    id: "7",
                    name: "大英镇敬老院",
                    address: "来安县伏岭镇水村",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "程训建",
                    phone: "13365635949",
                    longitude: "118.59775",
                    latitude: "32.295551",
                    build: "2012",
                    area: "占地5860m²，建筑2622m²",
                },
                {
                    id: "8",
                    name: "张山镇敬老院",
                    address: "来安县家朋乡家朋村和阳村",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "汪六园",
                    phone: "13805622623",
                    longitude: "118.498851",
                    latitude: "32.496037",
                    build: "2012",
                    area: "占地854m²，建筑1252.2m²",
                },
                {
                    id: "9",
                    name: "独山镇敬老院",
                    address: "来安县荆州乡下胡家村",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "胡金水",
                    phone: "17356333996",
                    longitude: "118.651457",
                    latitude: "32.403991",
                    build: "2012",
                    area: "占地350m²，建筑700m²",
                },
                {
                    id: "10",
                    name: "三城乡敬老院",
                    address: "来安县瀛洲镇瀛洲村",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "章玉秋",
                    phone: "17756934637",
                    longitude: "118.450073",
                    latitude: "32.25309",
                    build: "2010",
                    area: "占地6670m²，建筑3000m²",
                },
                {
                    id: "11",
                    name: "杨郢乡敬老院",
                    address: "来安县瀛洲镇瀛洲村",
                    nature: "公建公营",
                    houserNature: "社会服务用房",
                    person: "王名秋",
                    phone: "17756934637",
                    longitude: "118.46178",
                    latitude: "32.644449",
                    build: "2010",
                    area: "占地6670m²，建筑3000m²",
                },
            ],
            info: {
                id: "",
                name: "",
                address: "",
                nature: "",
                houserNature: "",
                person: "",
                phone: "",
                build: "",
                area: "",
            },
            totalOccupancyRatio: "",
            eldlyData: [], //列表数据
            pageOne: { total: 0, pageSize: 10, pageNo: 1 },
            step: 0,
            tableData: [
                {
                    date: "001",
                    name: "王小虎",
                    address: "上海市",
                },
            ],
            mechanism: false,
            olderInfoVisible: false,
            objList: {},
            xunList: {},
            xunInfoVisible: false,
            map: null,
            marker: null,
            onFullScreen: false,
            recMarker: null,
            scrollHeight: 620,
            communityList2: [],
            communityList: [],
            orgsData: [],
            markers: [],
            tableList: [],
            insList: [
                {
                    id: "149",
                    insName: "安全巡检",
                    startTime: "2021/12/8 16:54:52",
                    endTime: "2021/12/8 00:00:00",
                    insPersonName: "wangq",
                },
                {
                    id: "149",
                    insName: "消防巡检",
                    startTime: "2021/12/10 00:00:00",
                    endTime: "2021/12/11 00:00:00",
                    insPersonName: "wangq",
                },
                {
                    id: "149",
                    insName: "街道巡检",
                    startTime: "2021/12/18 16:55:54",
                    endTime: "2021/12/19 00:00:00",
                    insPersonName: "wangq",
                },
                {
                    id: "149",
                    insName: "卫生巡检",
                    startTime: "2021/12/26 80:00:00",
                    endTime: "2021/12/26 16:00:00",
                    insPersonName: "wangq",
                },
                {
                    id: "149",
                    insName: "门锁安全巡检",
                    startTime: "2021/12/28 12:54:52",
                    endTime: "2021/12/28 17:00:00",
                    insPersonName: "wangq",
                },
                {
                    id: "149",
                    insName: "卫生巡检",
                    startTime: "2021/1/2 00:00:00",
                    endTime: "2021/1/3 00:00:00",
                    insPersonName: "wangq",
                },
            ],
            communityId: "",
            oldInfo: {},
            infoWindow: {},
            BedNum: [], //床位数
            BedName: [], //床位数对应名称
            Occupancy: [], //入住比例
            Infors: [], //
            Ability: [], //入住老人能力评估
            Levels: [], //机构等级
            Statistics: [], //机构统计
            Care: [], //医养结合覆盖率
            CareStatistics: [], //
            occupancyElderlyNum0: 35,
            occupancyElderlyNum1: 21,
            occupancyElderlyNum2: 59,
            occupancyElderlyNum3: 60,
            occupancyElderlyNum4: 69,
            occupancyElderlyNum5: 36,
            occupancyElderlyNum6: 45,
            occupancyElderlyNum7: 43,
            occupancyElderlyNum8: 33,
            occupancyElderlyNum9: 39,
            occupancyElderlyNum10: 45,
            mechanism0: "",
            mechanism1: "",
            mechanism2: "",
            mechanism3: "",
            sumMechanism: 0,
            sumBed: 0,
        }
    },
    computed: {
        defaultOption() {
            return {
                step: 0.5, // 数值越大速度滚动越快
                limitMoveNum: 6, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: true, // 是否开启鼠标悬停stop
                direction: 1, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            }
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.loadMap().then(() => {
                this.getDistrict()
                this.showditu()
                this.bathPoint()
            })
        })
        this.getComList() //定位
        this.getBed() //床位数
        this.getOld()
        this.getCombination()
        this.geteldList()

        // 数据
        // console.log(this.$refs.ability);
        this.getelderlyData() //获取所有数据
        // this.getPolygon();

        // this.getData();
        // this.getinsData()
        const self = this
        document.addEventListener(
            "fullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )
        document.addEventListener(
            "msfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "mozfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "webkitfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )
    },
    methods: {
        handleCloses() {
            this.dialogVisibles = false
        },
        dialogervices() {
            this.dialogVisibles = true
        },
        // 批量打点
        bathPoint() {
            const self = this
            let f1 = require("./assets/big/jigou44.png")
            this.stationList.forEach((item, i) => {
                let icon = f1
                let marker = new AMap.Marker({
                    position: [item.longitude, item.latitude],
                    icon: new AMap.Icon({
                        image: icon,
                        size: new AMap.Size(52, 52), //图标大小
                        imageSize: new AMap.Size(30, 30),
                    }),
                    extData: {
                        id: item.id,
                        name: item.name,
                        address: item.address,
                        nature: item.nature,
                        houserNature: item.houserNature,
                        person: item.person,
                        phone: item.phone,
                        build: item.build,
                        area: item.area,
                    },
                })
                self.markers.push(marker)

                marker.on("click", self.maskModel)
            })
            self.map.add(self.markers)
        },
        maskModel(e) {
            let data = e.target.w.extData
            this.info = {
                name: data.name,
                id: data.id,
                address: data.address,
                nature: data.nature,
                houserNature: data.houserNature,
                person: data.person,
                phone: data.phone,
                build: data.build,
                area: data.area,
            }
            this.mechanism = true
            // console.log(e.target.w.extData, "点击事件")
        },
        drawArea() {
            for (let i = 0; i < this.areaList.length; i++) {
                // console.log(this.areaList,'2222')
                this.getArea(this.areaList[i].adcode, this.areaList[i].color)
            }
        },
        getArea(name, color) {
            // console.log(name, color)
            const self = this
            var opts = {
                subdistrict: 1, //返回下一级行政区
                extensions: "all",
                showbiz: false, //最后一级返回街道信息
            }
            let district = new AMap.DistrictSearch(opts)

            try {
                self.map.remove(self.marker)
            } catch (err) {
                console.log(err)
            }
            self.marker = new AMap.Marker()
            district.search(name, (status, result) => {
                if (status == "complete") {
                    let bounds = result.districtList[0].boundaries
                    self.polygons = []
                    for (var i = 0, l = bounds.length; i < l; i++) {
                        self.polygon = new AMap.Polygon({
                            map: self.map,
                            strokeWeight: 1,
                            strokeColor: "#007CDB",
                            fillColor: color,
                            fillOpacity: 0.06,
                            path: bounds[i],
                        })
                        self.polygons.push(self.polygon)
                    }
                    // self.map.setFitView() //地图自适应
                }
            })
        },
        getDistrict(name = "341122", params = null) {
            let self = this
            // return new Promise((resolve, reject) => {
            var opts = {
                subdistrict: 1, //返回下一级行政区
                extensions: "all",
                showbiz: false, //最后一级返回街道信息
            }
            let district = new AMap.DistrictSearch(opts)

            try {
                self.map.remove(self.marker)
            } catch (err) {
                console.log(err)
            }

            self.marker = new AMap.Marker()
            district.search(name, (status, result) => {
                if (status == "complete") {
                    let areaList = []
                    result.districtList[0].districtList.forEach((item) => {
                        // console.log(item, "下次code")
                        areaList.push({
                            adcode: item.adcode,
                            name: item.name,
                        })
                    })
                    // areaList[0].color = "#24609C"
                    // areaList[1].color = "#467399"
                    // areaList[2].color = "#0C2FA0"
                    // areaList[3].color = "#3769A6"
                    // areaList[4].color = "#22598D"
                    // areaList[5].color = "#326A9D"
                    // areaList[6].color = "#0C2FA0"
                    // areaList[7].color = "#2568A2"
                    // areaList[8].color = "#134CA2"
                    // areaList[9].color = "#183B77"
                    // areaList[10].color = "#183B70"
                    // areaList[11].color = "#183B70"

                    self.areaList = areaList
                    self.drawArea()
                }
            })
        },
        loadMap() {
            //地图加载
            return new Promise((resolve, reject) => {
                this.map = new AMap.Map("container", {
                    resizeEnable: true,
                    mapStyle: "amap://styles/darkblue",
                    zoom: 10,
                    center: ["118.432581", "32.423072"],
                })
                this.setArea()
                resolve()
            })
        },
        setArea() {
            let arr = [
                {
                    pointPosition:
                        "118.50145:32.721362,118.49939:32.711732,118.519561:32.676916,118.535611:32.676555,118.538529:32.67576,118.538357:32.672003,118.532349:32.668679,118.526513:32.663477,118.51175:32.654806,118.50557:32.651626,118.49733:32.645845,118.495614:32.641219,118.492524:32.634281,118.493897:32.626185,118.494927:32.607677,118.511407:32.58743,118.512093:32.579909,118.512093:32.572966,118.51278:32.567179,118.521706:32.560235,118.531319:32.558498,118.542306:32.561392,118.549859:32.55792,118.551919:32.558498,118.556768:32.560343,118.569557:32.586273,118.574878:32.588334,118.577968:32.593613,118.592045:32.598965,118.599769:32.603809,118.608953:32.597518,118.621828:32.594915,118.624918:32.591733,118.628694:32.590287,118.632428:32.580054,118.638221:32.581645,118.643071:32.588696,118.650452:32.592818,118.65307:32.598748,118.654958:32.599001,118.658306:32.598458,118.664056:32.596,118.679451:32.596589,118.689086:32.589719,118.701553:32.589701,118.703218:32.600432,118.699115:32.602867,118.70092:32.606048,118.700775:32.613264,118.696054:32.616951,118.695679:32.618515,118.702202:32.621723,118.704133:32.627135,118.685368:32.634318,118.675412:32.6314,118.673749:32.63327,118.671539:32.635692,118.666003:32.637833,118.665573:32.641506,118.674414:32.64895,118.682482:32.649167,118.687289:32.652563,118.693726:32.650973,118.695357:32.651985,118.693125:32.660368,118.698618:32.666437,118.699562:32.673662,118.694842:32.692734,118.697846:32.69779,118.700764:32.700318,118.712008:32.703568,118.716299:32.715196,118.713553:32.718445,118.706429:32.716712,118.69982:32.721695,118.695958:32.721767,118.689434:32.728699,118.679135:32.728554,118.657505:32.735414,118.652356:32.741406,118.647377:32.742128,118.640339:32.744077,118.633473:32.739023,118.628237:32.742056,118.619053:32.740467,118.60738:32.728266,118.591502:32.723211,118.583948:32.722995,118.571846:32.718301,118.569701:32.719601,118.564894:32.729277,118.559272:32.729854,118.538287:32.727435,118.535626:32.727652,118.530905:32.726208,118.529188:32.725847,118.526184:32.726858,118.520434:32.723536,118.51228:32.725341",
                    gridColour: "1565C0",
                    orgName: "半塔镇",
                },
                {
                    pointPosition:
                        "118.402236:32.551454,118.420221:32.55816,118.422324:32.559715,118.428418:32.567257,118.413273:32.586431,118.406117:32.595628,118.39954:32.595749,118.395614:32.596797,118.39158:32.595496,118.376162:32.597295,118.370851:32.592965,118.365133:32.582063,118.35685:32.573384,118.353374:32.566368,118.34492:32.564342,118.34286:32.560798,118.342216:32.557434,118.346851:32.552514,118.347881:32.547052,118.351872:32.540685,118.336337:32.515501,118.336895:32.498491,118.33874:32.49708,118.34286:32.500627,118.347581:32.495632,118.354576:32.477604,118.351743:32.475251,118.342259:32.476953,118.341959:32.476989,118.342989:32.483035,118.339126:32.484374,118.333461:32.482383,118.328355:32.474817,118.331702:32.462398,118.331444:32.461963,118.324235:32.460985,118.319385:32.455807,118.31887:32.448275,118.330801:32.440887,118.332689:32.443965,118.336766:32.445667,118.336895:32.445559,118.337324:32.442842,118.340113:32.44277,118.345778:32.436576,118.344748:32.429912,118.352516:32.42926,118.354962:32.41861,118.354962:32.418139,118.348954:32.413139,118.348793:32.412994,118.350284:32.412188,118.350201:32.412233,118.350169:32.411799,118.350582:32.412199,118.3511:32.412358,118.352425:32.412415,118.353178:32.412034,118.355851:32.411244,118.359348:32.411389,118.365678:32.412648,118.38072:32.414577,118.389496:32.412711,118.400826:32.399414,118.445072:32.398436,118.471636:32.40224,118.473053:32.43307,118.476143:32.444515,118.473053:32.483403,118.472945:32.483874,118.455853:32.481793,118.409418:32.486064,118.401865:32.490046,118.402209:32.497358,118.400921:32.506985,118.392767:32.511039,118.388132:32.514296,118.383583:32.52204,118.385386:32.531954,118.401608:32.550712,118.401608:32.550712,118.40197:32.551144",
                    gridColour: "1565C0",
                    orgName: "新安镇",
                },
                {
                    pointPosition:
                        "118.480365:32.259,118.484753:32.255661,118.494623:32.247724,118.531444:32.229575,118.539555:32.226997,118.55007:32.221697,118.558309:32.216904,118.568051:32.218139,118.58335:32.201572,118.585807:32.20051,118.588833:32.200301,118.590308:32.200637,118.59217:32.200206,118.592336:32.200097,118.592363:32.195319,118.594742:32.194706,118.597035:32.199759,118.610564:32.202383,118.619147:32.205869,118.62758:32.202709,118.629747:32.203345,118.636721:32.207757,118.644274:32.210335,118.649832:32.217724,118.666225:32.23368,118.671976:32.245132,118.67586:32.254641,118.673907:32.25622,118.66998:32.256456,118.660645:32.261555,118.649187:32.259704,118.647921:32.259976,118.646188:32.261323,118.644954:32.262153,118.642937:32.263242,118.641693:32.262879,118.640019:32.265057,118.596031:32.278287,118.584358:32.274223,118.567192:32.27045,118.548309:32.271611,118.534919:32.273062,118.514663:32.272482,118.505737:32.272772,118.502304:32.273353,118.497154:32.274223,118.493034:32.274804,118.483764:32.275385,118.483421:32.275385,118.481361:32.273788,118.480503:32.272191,118.481704:32.269288,118.484107:32.268272,118.482906:32.264208,118.481532:32.262031,118.480846:32.260126",
                    gridColour: "FC466B",
                    orgName: "汉河镇",
                },
                {
                    pointPosition:
                        "118.406144:32.595644,118.413407:32.586327,118.413517:32.586485,118.420558:32.577698,118.428283:32.566704,118.466391:32.571912,118.473601:32.577409,118.480468:32.580302,118.487334:32.578277,118.490424:32.57249,118.493514:32.566704,118.49832:32.558313,118.512397:32.567246,118.511753:32.573033,118.511753:32.579868,118.511195:32.587389,118.49472:32.607773,118.493733:32.62628,118.492317:32.634376,118.495643:32.641351,118.497295:32.64603,118.505471:32.651631,118.52651:32.663496,118.532314:32.668698,118.538349:32.672006,118.538523:32.675756,118.535609:32.676553,118.519553:32.676912,118.499377:32.711737,118.5014:32.721356,118.490725:32.723875,118.490124:32.722972,118.489974:32.722728,118.487098:32.721501,118.483901:32.720427,118.480135:32.722404,118.479588:32.722485,118.474878:32.721059,118.469599:32.721275,118.466531:32.722458,118.464943:32.723595,118.461403:32.724064,118.458774:32.725328,118.456843:32.72948,118.454536:32.732566,118.451039:32.743883,118.448528:32.745616,118.441232:32.739606,118.431813:32.716735,118.427693:32.711806,118.418423:32.707184,118.414732:32.70072,118.419904:32.696079,118.421277:32.683908,118.428358:32.677406,118.434023:32.664148,118.431298:32.660065,118.42662:32.657229,118.420097:32.659595,118.415762:32.656181,118.414303:32.650508,118.415548:32.640318,118.419195:32.636469,118.427392:32.635078,118.427328:32.625807,118.417457:32.615452,118.413509:32.61462,118.409475:32.612704,118.408896:32.609686,118.41014:32.606053,118.410097:32.606053",
                    gridColour: "3F5EFB",
                    orgName: "杨郢乡",
                },
                {
                    pointPosition:
                        "118.402258:32.551458,118.419606:32.558199,118.422525:32.559863,118.424112:32.561346,118.428265:32.566681,118.466438:32.571904,118.473642:32.57741,118.480466:32.58024,118.487332:32.578224,118.498293:32.558294,118.496244:32.545145,118.493884:32.536969,118.496931:32.528756,118.49796:32.522351,118.494613:32.513196,118.488734:32.504727,118.490279:32.487208,118.486845:32.487244,118.474829:32.493362,118.472769:32.483869,118.456375:32.481862,118.442213:32.482224,118.42685:32.484722,118.410113:32.48617,118.402302:32.490152,118.402216:32.497536,118.4008:32.507381,118.39359:32.510747,118.387968:32.514221,118.383634:32.522037,118.385737:32.532349,118.392013:32.539558",
                    gridColour: "59C173",
                    orgName: "舜山镇",
                },
                {
                    pointPosition:
                        "118.577353:32.550531,118.572665:32.543043,118.574682:32.536205,118.576012:32.535373,118.579102:32.534866,118.580003:32.53407,118.58202:32.530597,118.582192:32.524699,118.575326:32.51985,118.556646:32.520256,118.5545:32.520921,118.551453:32.518605,118.545745:32.515239,118.539566:32.51466,118.533558:32.513285,118.529695:32.510462,118.527292:32.497143,118.529953:32.49584,118.551153:32.492872,118.539566:32.467168,118.538622:32.464054,118.539394:32.461809,118.557513:32.449868,118.558307:32.447967,118.55438:32.442806,118.540948:32.441205,118.52052:32.440119,118.511079:32.439612,118.504813:32.425423,118.506186:32.412961,118.5376:32.403831,118.483355:32.379044,118.478377:32.379044,118.473227:32.379479,118.472712:32.380059,118.471339:32.379479,118.453143:32.378754,118.444388:32.37252,118.438037:32.364872,118.43279:32.352714,118.430269:32.354019,118.427206:32.360742,118.414867:32.366989,118.411047:32.371665,118.40609:32.370976,118.402679:32.367352,118.399975:32.367714,118.389611:32.372897,118.391778:32.377084,118.384654:32.385751,118.382026:32.381407,118.376683:32.387378,118.372531:32.390096,118.368958:32.390449,118.366919:32.39333,118.371533:32.394055,118.375095:32.402352,118.376597:32.404273,118.37694:32.407606,118.372048:32.410903,118.36222:32.406882,118.35647:32.406555,118.35029:32.408838,118.349971:32.408931,118.350185:32.411748,118.350182:32.411795,118.350561:32.412176,118.350756:32.412232,118.350866:32.412269,118.351121:32.412371,118.35243:32.412414,118.353203:32.412024,118.355778:32.411254,118.359372:32.41139,118.364704:32.4125,118.365798:32.412681,118.380647:32.41451,118.38938:32.412717,118.400753:32.399402,118.444998:32.398568,118.471606:32.402264,118.473108:32.432442,118.47637:32.44577,118.47225:32.483862,118.474825:32.493237,118.486841:32.487265,118.490317:32.487301,118.488772:32.504783,118.494652:32.51318,118.498085:32.522444,118.497012:32.52874,118.493922:32.537061,118.496282:32.545129,118.498428:32.558369,118.512581:32.56722,118.521679:32.560203,118.531743:32.558394,118.531306:32.558473,118.542304:32.561365,118.549868:32.557892,118.55196:32.558471,118.556842:32.560343,118.558644:32.555415,118.56315:32.551978,118.575252:32.550739",
                    gridColour: "19D313",
                    orgName: "张山镇",
                },
                {
                    pointPosition:
                        "118.610594:32.472291,118.607447:32.439745,118.624785:32.435108,118.628733:32.425836,118.629591:32.41888,118.62736:32.413374,118.618433:32.409171,118.611395:32.402214,118.608477:32.394242,118.607619:32.391923,118.590109:32.389024,118.587191:32.391488,118.579123:32.389604,118.578951:32.399895,118.563845:32.39946,118.552:32.405548,118.545649:32.405982,118.53764:32.403854,118.506239:32.412918,118.504716:32.425471,118.51111:32.439488,118.540937:32.441118,118.554283:32.442712,118.558274:32.447818,118.557459:32.450136,118.539477:32.461833,118.538619:32.464223,118.539649:32.467336,118.55124:32.492887,118.529825:32.495999,118.527465:32.497158,118.529782:32.510368,118.533259:32.513191,118.539868:32.514675,118.545661:32.515218,118.551455:32.518474,118.554545:32.520899,118.556862:32.52032,118.575487:32.51985,118.582311:32.524662,118.582053:32.530958,118.580079:32.534251,118.57935:32.534938,118.575992:32.535454,118.574715:32.536195,118.572685:32.543045,118.577384:32.550558,118.609312:32.535044,118.608915:32.53219,118.605391:32.531032,118.605242:32.531009,118.602519:32.530188,118.603545:32.521139,118.606463:32.518189,118.617063:32.516597,118.618179:32.515566,118.616785:32.50831,118.616779:32.508132,118.610374:32.507114,118.608883:32.502065,118.592249:32.502157,118.593333:32.496239,118.591595:32.484366,118.594298:32.47785,118.59786:32.476329,118.605199:32.47756",
                    gridColour: "133DD3",
                    orgName: "施官镇",
                },

                {
                    pointPosition:
                        "118.607646:32.391909,118.608898:32.385628,118.609992:32.384378,118.611473:32.383308,118.613103:32.383109,118.616515:32.387857,118.627591:32.396598,118.628879:32.397178,118.630338:32.396308,118.636432:32.38935,118.648169:32.372643,118.648599:32.372534,118.670802:32.380435,118.667197:32.388263,118.6693:32.390039,118.671446:32.39022,118.680276:32.388462,118.677744:32.393862,118.685271:32.404388,118.688619:32.418953,118.685958:32.429241,118.689477:32.45032,118.691515:32.452619,118.690872:32.455824,118.68585:32.454339,118.683619:32.458975,118.685486:32.460061,118.690721:32.459319,118.69176:32.465047,118.690772:32.472269,118.685751:32.472957,118.673435:32.4693,118.649831:32.47665,118.64245:32.470061,118.631721:32.470712,118.63009:32.468685,118.627215:32.467852,118.619404:32.472305,118.610599:32.472299,118.607468:32.439799,118.624903:32.435109,118.628808:32.425582,118.629666:32.418808,118.627392:32.413374,118.618294:32.409099,118.611384:32.402106,118.611384:32.402106,118.611384:32.402106,118.607653:32.391981",
                    gridColour: "171E98",
                    orgName: "独山镇",
                },
                {
                    pointPosition:
                        "118.608894:32.385623,118.609332:32.378157,118.591737:32.337483,118.571653:32.336033,118.566159:32.333422,118.560666:32.327765,118.597573:32.31616,118.619031:32.317611,118.635167:32.303175,118.639545:32.299693,118.642463:32.29933,118.648814:32.296791,118.657092:32.299598,118.65714:32.301934,118.659586:32.305272,118.670744:32.309932,118.674692:32.314158,118.676559:32.315826,118.686794:32.318347,118.69497:32.317404,118.697266:32.318165,118.696386:32.320777,118.694004:32.321973,118.68894:32.321955,118.684134:32.323751,118.682975:32.326543,118.684134:32.327703,118.687846:32.330369,118.697116:32.329063,118.703446:32.329607,118.706857:32.332291,118.707716:32.338292,118.704905:32.339996,118.697395:32.341936,118.695957:32.346015,118.699583:32.349513,118.694047:32.349731,118.692184:32.352554,118.69536:32.357086,118.699308:32.357231,118.702012:32.357956,118.701969:32.358209,118.69978:32.359949,118.695961:32.360819,118.696304:32.364843,118.695704:32.367852,118.697592:32.36941,118.700596:32.368078,118.702312:32.36777,118.703697:32.368223,118.703396:32.371948,118.702109:32.373062,118.697731:32.373325,118.696809:32.375327,118.700692:32.376687,118.701787:32.377937,118.701572:32.379595,118.698514:32.383328,118.696133:32.383808,118.694019:32.382513,118.693729:32.380175,118.692345:32.377692,118.690747:32.377384,118.688215:32.38437,118.680254:32.38842,118.671424:32.390214,118.669235:32.390014,118.667218:32.388257,118.670856:32.380402,118.648668:32.372518,118.648089:32.372663,118.636395:32.389371,118.630279:32.396383,118.628841:32.397144,118.627618:32.3966,118.616503:32.387831,118.612984:32.383029,118.611353:32.383337,118.609916:32.384388",
                    gridColour: "EE1919",
                    orgName: "雷官镇",
                },
                {
                    pointPosition:
                        "118.573571:32.323689,118.55366:32.30881,118.552072:32.307632,118.550978:32.305709,118.55042:32.304367,118.559715:32.298275,118.567011:32.293922,118.573759:32.271899,118.584359:32.274222,118.596107:32.27844,118.640095:32.265041,118.641705:32.262909,118.642928:32.263254,118.644999:32.262165,118.646265:32.261312,118.64738:32.260441,118.647895:32.259988,118.649236:32.259716,118.66095:32.261614,118.658892:32.26583,118.663365:32.274396,118.670446:32.285172,118.669802:32.292755,118.66697:32.295983,118.660404:32.295693,118.657067:32.299593,118.648805:32.296768,118.642443:32.299316,118.639514:32.299679,118.619029:32.317599,118.59754:32.316142",
                    gridColour: "2EE919",
                    orgName: "大英镇",
                },
                {
                    pointPosition:
                        "118.421426:32.265965,118.424526:32.264885,118.425825:32.263706,118.441392:32.265602,118.450276:32.266999,118.455254:32.268251,118.462732:32.267852,118.480358:32.259023,118.481511:32.262017,118.482895:32.264221,118.484097:32.268267,118.481683:32.269283,118.480503:32.272186,118.481372:32.27381,118.483399:32.275361,118.493141:32.274808,118.497347:32.274209,118.504761:32.27293,118.505876:32.272749,118.514019:32.272486,118.515232:32.272458,118.534994:32.273066,118.549175:32.27156,118.5675:32.270399,118.57376:32.271897,118.567029:32.293912,118.564733:32.295227,118.55042:32.304405,118.552137:32.307724,118.573562:32.323697,118.560658:32.327764,118.566312:32.333593,118.571763:32.336131,118.591761:32.337509,118.609324:32.378165,118.608898:32.38564,118.607637:32.391919,118.590095:32.388954,118.58722:32.391454,118.579109:32.389606,118.578809:32.399861,118.563788:32.39939,118.551815:32.405586,118.545464:32.406021,118.53761:32.403847,118.483365:32.378987,118.473151:32.379386,118.472711:32.38002,118.471263:32.379431,118.45293:32.378645,118.444003:32.372193,118.437566:32.364255,118.43291:32.352745,118.436772:32.35057,118.435506:32.345404,118.43851:32.342177,118.437158:32.34031,118.421108:32.338297,118.419262:32.337318,118.419198:32.3342,118.424992:32.324935,118.431129:32.319749,118.43115:32.317699,118.42821:32.311606,118.434497:32.308215,118.428918:32.296154,118.429187:32.275365,118.423099:32.268019",
                    gridColour: "DFC925",
                    orgName: "水口镇",
                },
                {
                    pointPosition:
                        "118.421418:32.265923,118.419299:32.263414,118.415383:32.264031,118.408817:32.269461,118.40268:32.26996,118.397186:32.268799,118.396006:32.264761,118.395899:32.260552,118.397369:32.258855,118.399257:32.258737,118.400115:32.260461,118.401982:32.261867,118.404375:32.261269,118.405694:32.257785,118.404858:32.253538,118.40636:32.252949,118.411456:32.252386,118.415533:32.247459,118.416863:32.247214,118.419835:32.248403,118.42256:32.248612,118.423719:32.245926,118.423408:32.243222,118.416681:32.241933,118.415511:32.241298,118.415683:32.23814,118.416037:32.235644,118.416065:32.235439,118.414198:32.233034,118.415142:32.23092,118.420174:32.229967,118.423049:32.227943,118.424433:32.223432,118.428768:32.219057,118.429122:32.215381,118.430838:32.212894,118.43469:32.210933,118.440505:32.210252,118.444732:32.204315,118.446545:32.204515,118.449099:32.208255,118.450504:32.208872,118.456823:32.206766,118.457821:32.206857,118.458808:32.210407,118.460246:32.211332,118.463347:32.210243,118.463904:32.208001,118.461297:32.205232,118.460439:32.203834,118.462027:32.202618,118.463776:32.202318,118.466715:32.204379,118.468539:32.205296,118.470621:32.20535,118.472434:32.203144,118.472509:32.200048,118.474269:32.19875,118.489355:32.198384,118.496683:32.196731,118.508606:32.195096,118.517704:32.189321,118.522553:32.188195,118.526158:32.189902,118.529978:32.194714,118.532338:32.196131,118.539462:32.192408,118.548324:32.195096,118.548903:32.198273,118.550899:32.200144,118.556371:32.198419,118.561327:32.196821,118.566563:32.199835,118.562829:32.202885,118.569567:32.20343,118.572314:32.206843,118.57785:32.204519,118.576605:32.20245,118.579051:32.199327,118.584802:32.198818,118.588858:32.200298,118.585789:32.200507,118.583322:32.201578,118.568001:32.218118,118.558173:32.216883,118.550105:32.221712,118.540192:32.226722,118.530793:32.229772,118.494401:32.247776,118.480357:32.259014,118.462703:32.267827,118.455235:32.268226,118.449914:32.26692,118.441867:32.265668,118.425624:32.263636,118.424487:32.264861,118.424117:32.264995",
                    gridColour: "1EF705",
                    orgName: "三城镇",
                },
            ]
            arr.forEach((item) => {
                let polygonArr = []
                if (item.pointPosition) {
                    item.pointPosition.split(",").forEach((e) => {
                        polygonArr.push(e.split(":"))
                    })
                    var polygon = new AMap.Polygon({
                        map: this.map,
                        path: polygonArr, //设置多边形边界路径
                        strokeColor: "#" + item.gridColour, //线颜色
                        strokeOpacity: 0.2, //线透明度
                        strokeWeight: 3, //线宽
                        fillColor: "#" + item.gridColour, //填充色
                        fillOpacity: 0.35, //填充透明度
                        // extData: {
                        //     name: item.orgName,
                        // },
                    })
                    this.text3 = new AMap.Text({
                        text: item.orgName,
                        anchor: "center", //  设置文本标记锚点
                        draggable: true,
                        cursor: "pointer",
                        angle: 10,
                        style: {
                            "text-align": "center",
                            "font-size": "15px",
                            "background-color": "transparent",
                            color: "#fff",
                            "border-width": 0,
                        },
                        position: this.getCenterPoint(polygonArr),
                    })
                    this.text3.setMap(this.map)
                }
            })
        },
        getCenterPoint(data) {
            var lng = 0.0,
                lat = 0.0
            for (var i = 0; i < data.length; i++) {
                // if ($.isEmptyObject(data[i])) {
                // continue;
                // }
                lng = lng + parseFloat(data[i]["lng"])
                lat = lat + parseFloat(data[i]["lat"])
            }
            lng = lng / data.length
            lat = lat / data.length
            return [lng, lat]
        },
        //老人列表数据
        async geteldList(id) {
            let params = {
                pageNo: this.pageOne.pageNo,
                pageSize: this.pageOne.pageSize,
            }

            this.tableList = [
                {
                    id: "1",
                    customerName: "魏正龙",
                    gender: "男",
                    selfCare: "半自理",
                    address: "新河社区",
                },
                {
                    id: "2",
                    customerName: "付多贤",
                    gender: "男",
                    selfCare: "自理",
                    address: "新河社区东花园2幢303",
                },
                {
                    id: "3",
                    customerName: "项铭宾",
                    gender: "男",
                    selfCare: "自理",
                    address: "新河社区东花园1幢402",
                },
                {
                    id: "4",
                    customerName: "刘华",
                    gender: "男",
                    selfCare: "半失能",
                    address: "新河社区名都城",
                },
                {
                    id: "5",
                    customerName: "付传杰",
                    gender: "男",
                    selfCare: "半自理",
                    address: "新河社区西花园",
                },
                {
                    id: "6",
                    customerName: "李红",
                    gender: "女",
                    selfCare: "半失能",
                    address: "新河社区严墩小区11幢1室",
                },
                {
                    id: "7",
                    customerName: "包玉升",
                    gender: "男",
                    selfCare: "半自理",
                    address: "新河社区住汊河",
                },
            ]
        },

        // 当前页
        handleTableDataChange(val) {
            this.pageOne.pageNo = val
            this.geteldList()
        },
        // 分页大小
        handletableDataSize(val) {
            this.pageOne.pageSize = val
            this.geteldList()
        },
        // 按钮切换
        stepTap(nums) {
            this.step = nums

            const box = document.getElementById("box")
            const box2 = document.getElementById("box2")
            if (nums == 0) {
                box.style.fontSize = "25px"
                box2.style.fontSize = "20px"
            }
            if (nums == 3) {
                box.style.fontSize = "20px"
                box2.style.fontSize = "25px"
            }
        },
        async getComList() {
            // let params = {
            //       pageNo: 1,
            //       pageSize: 10,
            //   }
            //   this.$http
            //       .request({
            //           // url: "/ypt/admin/mechanismCare/info/findList",
            //           url: "/ypt/admin/mechanismCare/info/findListVisualization",
            //           method: "POST",
            //           data: params,
            //       })
            //       .then((res) => {
            //           if (res.code == 200) {
            //               if (res.content == null || res.content == "null") {
            //                   this.communityList = []
            //                   return
            //               }
            //               this.$set(this,'communityList',res.content.list)
            //               // this.communityList = res.content.list
            //               // this.markets();
            //           }
            //       })
        },
        //社区图标
        async showditu() {
            this.map.remove(this.markers)
            this.markers = []
            this.renderMapMarker(this.communityList)
        },
        renderMapMarker(data) {
            let self = this
            console.log(data, "QWeqqwe")
            if (data.length) {
                var endIcon = new AMap.Icon({
                    size: new AMap.Size(49, 56),
                    image: require("./assets/big/f1.png"),
                    imageSize: new AMap.Size(38, 42),
                })
                console.log(data.longitude, data.latitude)
                data.forEach((item) => {
                    let marker = new AMap.Marker({
                        position: [
                            item.longitude || item.addressLng,
                            item.latitude || item.addressLat,
                        ],
                        icon: endIcon,
                    })
                    self.markers.push(marker)
                    marker.on("mouseover", (e) => {})
                    marker.on("click", (e) => {})
                })
            }
            self.map.add(self.markers)
            // self.map.setFitView(self.markers)
            self.map.setCenter([118.84315, 32.458977])
        },
        markets() {
            //  this.getPolygon()
            this.map = new AMap.Map("party-map", {
                zoom: 13,
                zooms: [3, 20],
                center: [118.638, 32.049],
                showLabel: false,
                mapStyle: "amap://styles/darkblue",
            })
            // console.log(this.communityList,'this.communityList')
            let m1 = require("./assets/big/jigou11.png")
            let m2 = require("./assets/big/jigou22.png")
            let m3 = require("./assets/big/jigou33.png")
            let m4 = require("./assets/big/jigou44.png")
            // for (var i = 0; i < this.communityList.length; i++) {
            //   var icon2 = ""
            //   if (i == 1) {
            //     icon2 = m1;
            //   } else if (i ==2 ) {
            //     icon2 = m2;
            //   } else if (i == 3) {
            //     icon2 = m3;
            //   } else if (i == 4) {
            //     icon2 = m4;
            //   }
            // }
            this.communityList.forEach((item, i) => {
                var icon2 = ""
                if (i == 0) {
                    icon2 = m1
                } else if (i == 1) {
                    icon2 = m2
                } else if (i == 2) {
                    icon2 = m3
                } else if (i == 3) {
                    icon2 = m4
                }
                if (item.longitude && item.latitude) {
                    var marker = new AMap.Marker({
                        position: [item.longitude, item.latitude],
                        icon: new AMap.Icon({
                            image: icon2,
                            size: new AMap.Size(52, 52), //图标大小
                            imageSize: new AMap.Size(30, 30),
                        }),

                        map: this.map,
                    })
                    this.markers.push(marker)
                    marker.setLabel({
                        offset: new AMap.Pixel(12, 12),
                        content: item.organizationName,
                        direction: "center",
                    })
                    marker.on("click", (e) => {
                        this.mechanism = true
                        console.log(item)
                        this.getById(item.id)
                        this.getData(item.id)
                        this.geteldList(item.id)
                        this.getelderlyData(item.id) //根据不同的机构变换不同的老人数据
                    })
                }
            })
        },
        getById(id) {
            let self = this
            self.$http
                .request({
                    url: "/ypt/admin/mechanismCare/info/get",
                    method: "POST",
                    data: {
                        id: id,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        self.orgsData = res.content
                    }
                })
        },
        // 关闭弹窗
        close() {
            this.mechanism = false
        },
        // 点击显示老人信息
        showInfo(e) {
            let item = JSON.parse(e.target.dataset.obj)
            this.objList = item
            console.log(this.objList, item)
            // this.olderInfoVisible = true;
        },
        showXunInfo(e) {
            let item = JSON.parse(e.target.dataset.obj)
            this.xunList = item
            console.log(this.xunList, item)
            this.xunInfoVisible = true
        },
        // 控制全屏展示
        showFullScreen() {
            this.onFullScreen = !this.onFullScreen
            if (this.onFullScreen) {
                var docElm = document.documentElement
                if (docElm.requestFullscreen) {
                    docElm.requestFullscreen()
                } else if (docElm.msRequestFullscreen) {
                    docElm = document.body //overwrite the element (for IE)
                    docElm.msRequestFullscreen()
                } else if (docElm.mozRequestFullScreen) {
                    docElm.mozRequestFullScreen()
                } else if (docElm.webkitRequestFullScreen) {
                    docElm.webkitRequestFullScreen()
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen()
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen()
                }
            }
        },
        FullCreeen(element) {
            let el = document.getElementById("bigdata")
            let rfs =
                el.requestFullScreen ||
                el.webkitRequestFullScreen ||
                el.mozRequestFullScreen ||
                el.msRequestFullScreen
            if (typeof rfs != "undefined" && rfs) {
                rfs.call(el)
            } else if (typeof window.ActiveXObject != "undefined") {
                let wscript = new ActiveXObject("WScript.Shell")
                if (wscript != null) {
                    wscript.SendKeys("{F11}")
                }
            }
        },
        markerClick(e) {
            // alert(11111111)
            this.infoWindow.setContent(e.target.content)
            this.infoWindow.open(this.map, e.target.getPosition())
            let cname = e.target.name //机构或者社区名称
            // this.getnewData(cname);
            this.mechanism = true
            this.getAbility()
            this.getBody()
            this.getCost()
            console.log(e)
        },

        async getnewData(n) {
            // findListVisualization
            var res = await request({
                url: "/ypt/admin/mechanismCarePeople/info/findListVisualization",
                method: "POST",
                data: {
                    communityId: this.communityId,
                    pageNo: 1,
                    pageSize: 10,
                },
            })
            if (res.code == 200) {
                this.tableList = res.content.elderlyInfors.filter((item) => {
                    return item.mechanism == n //显示对应社区滚动列表
                })
            }
        },

        // 入住老人数据
        async getData(CareId) {
            // findListVisualization
            var res = await request({
                url: "/ypt/admin/mechanismCarePeople/info/findListVisualization",
                method: "POST",
                data: {
                    mechanismCareId: CareId,
                    pageNo: 1,
                    pageSize: 10,
                },
            })
            if (res.code == 200) {
                // this.oldInfo = res.content;
                this.tableList = res.content.list
            }
        },
        // 巡检数据
        async getinsData() {
            // // findListVisualization
            // var res = await request({
            //   url: "/ypt/admin/securityIns/info/findListVisualization",
            //   method: "POST",
            //   data: {
            //     // communityId: this.communityId,
            //      pageNo:1,
            //      pageSize:10
            //   },
            // });
            // if (res.code == 200) {
            // this.oldInfo = res.content;
            //   this.insList = res.content.list;
            // }
        },
        async getelderlyData(CareId) {
            this.getOld() //机构等级覆盖率
            this.getCombination()
            this.getLodLiveEcharts() //入住老人能力评估
            this.getNursing() //评估能力比例
            if (CareId == undefined) {
                //首次初始化执行
                this.percentShow("num", "wave-mask", this.occupancyElderlyNum0)
                this.percentShow(
                    "num1",
                    "wave-mask1",
                    this.occupancyElderlyNum1
                )
                this.percentShow(
                    "num2",
                    "wave-mask2",
                    this.occupancyElderlyNum2
                )
                this.percentShow(
                    "num3",
                    "wave-mask3",
                    this.occupancyElderlyNum3
                )
                this.percentShow(
                    "num4",
                    "wave-mask4",
                    this.occupancyElderlyNum4
                )
                this.percentShow(
                    "num5",
                    "wave-mask5",
                    this.occupancyElderlyNum5
                )
                this.percentShow(
                    "num6",
                    "wave-mask6",
                    this.occupancyElderlyNum6
                )
                this.percentShow(
                    "num7",
                    "wave-mask7",
                    this.occupancyElderlyNum7
                )
                this.percentShow(
                    "num8",
                    "wave-mask8",
                    this.occupancyElderlyNum8
                )
                this.percentShow(
                    "num9",
                    "wave-mask9",
                    this.occupancyElderlyNum9
                )
                this.percentShow(
                    "num10",
                    "wave-mask10",
                    this.occupancyElderlyNum10
                )
            }
            this.getNursing()
        },
        // 入住能力评估比例
        getNursing() {
            const myChart = this.$echarts.init(document.getElementById("huli"))
            var option
            option = {
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}:  ({d}%)",
                },
                color: ["#c63c26", "#65AC3A", "#36cfc9", "#AC03E2"],
                series: [
                    {
                        name: "入住能力评估",
                        type: "pie",
                        radius: ["30%", "50%"],
                        center: ["50%", "50%"],
                        roseType: "area",
                        itemStyle: {
                            borderRadius: 5,
                        },
                        data: [
                            { name: "自理", value: 459 },
                            { name: "半自理", value: 210 },
                            { name: "失能", value: 30 },
                            { name: "半失能", value: 44 },
                        ],
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true,
                                    formatter: "{b} :({d}%)",
                                },
                                labelLine: { show: true },
                            },
                        },

                        label: {
                            formatter: function (params) {
                                var tempStr = params.data.name.substring(0, 3)
                                var tempStr1 = params.data.name.substring(
                                    3,
                                    params.data.name.length
                                )
                                var tempStr2 = tempStr + "\n" + tempStr1

                                return tempStr2
                            },
                        },
                    },
                ],
            }
            option && myChart.setOption(option)
        },
        //百分比
        percentShow(numl, wave, nums) {
            let timerRef = null
            let loading = 0
            let numEle = document.getElementById(numl)
            let maskEle = document.getElementById(wave)

            timerRef = setInterval(() => {
                const num = loading + 0.49
                if (num >= nums) {
                    loading = nums
                    clearInterval(timerRef)
                } else {
                    loading = num
                }
                numEle.innerHTML =
                    loading >= 100 ? 100 : loading.toFixed(2) + "%" // 显示两位小数
                maskEle.style.top = 100 - loading + "%"
            }, 150)
        },
        // 床位数
        getBed() {
            //  let xData=[],
            //      yData=[]
            //  this.BedNum.forEach(item=>{
            //        yData.push(item.bedNum)
            //        xData.push(item.organizationName)
            //   })
            const myChart = this.$echarts.init(document.getElementById("beds"))
            var option
            option = {
                grid: {
                    top: "10%",
                    left: "3%",
                    right: "4%",
                    bottom: "7%",
                    containLabel: true,
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                title: {
                    subtext: "床位数", //副标题
                    left: "15",
                    subtextStyle: {
                        //对应样式
                        color: "#00D2FF",
                        fontSize: 16,
                    },
                },

                color: [
                    "#7FD42D",
                    "#F21B62",
                    "#FFB026",
                    "#D800FF",
                    "#7FD42D",
                    "#F21B62",
                    "#FFB026",
                    "#D800FF",
                    "#7FD42D",
                    "#F21B62",
                    "#FFB026",
                    "#D800FF",
                ],
                xAxis: {
                    type: "category",
                    data: [
                        "新安镇",
                        "半塔镇",
                        "水口镇",
                        "汊河镇",
                        "大英镇",
                        "雷官镇",
                        "施官镇",
                        "舜山镇",
                        "三城乡",
                        "独山乡",
                        "张山乡",
                    ],
                    axisLine: {
                        lineStyle: {
                            type: "solid",
                            color: "#fff", //左边线的颜色
                            width: "1", //坐标线的宽度
                        },
                    },
                    // data: xData,
                    // data: xData,
                    // axisLabel: {
                    //     interval: 0,
                    //     rotate: 90,
                    // },
                    // axisLabel: {
                    //   // 坐标轴刻度标签换行处理
                    //   formatter: function (params) {
                    //     var newParamsName = ""; // 最终拼接成的字符串
                    //     var paramsNameNumber = params.length; // 实际标签的个数
                    //     var provideNumber = 4; // 每行能显示的字的个数
                    //     var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
                    //     /**
                    //      * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                    //      */
                    //     // 条件等同于rowNumber>1
                    //     if (paramsNameNumber > provideNumber) {
                    //       /** 循环每一行,p表示行 */
                    //       for (var p = 0; p < rowNumber; p++) {
                    //         var tempStr = ""; // 表示每一次截取的字符串
                    //         var start = p * provideNumber; // 开始截取的位置
                    //         var end = start + provideNumber; // 结束截取的位置
                    //         // 此处特殊处理最后一行的索引值
                    //         if (p == rowNumber - 1) {
                    //           // 最后一次不换行
                    //           tempStr = params.substring(start, paramsNameNumber);
                    //         } else {
                    //           // 每一次拼接字符串并换行
                    //           tempStr = params.substring(start, end) + "\n";
                    //         }
                    //         newParamsName += tempStr; // 最终拼成的字符串
                    //       }
                    //     } else {
                    //       // 将旧标签的值赋给新标签
                    //       newParamsName = params;
                    //     }
                    //     //将最终的字符串返回
                    //     return newParamsName;
                    //   },
                    // },
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        lineStyle: {
                            type: "solid",
                            color: "#fff", //左边线的颜色
                            width: "1", //坐标线的宽度
                        },
                    },
                },
                series: [
                    {
                        // data: yData,
                        data: [23, 33, 77, 86, 36, 64, 51, 88, 75, 33, 80],
                        itemStyle: {
                            normal: {
                                //这里是重点
                                color: function (params) {
                                    //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                                    var colorList = [
                                        "#7FD42D",
                                        "#F21B62",
                                        "#FFB026",
                                        "#D800FF",
                                        "#7FD42D",
                                        "#F21B62",
                                        "#FFB026",
                                        "#D800FF",
                                        "#7FD42D",
                                        "#F21B62",
                                        "#FFB026",
                                        "#D800FF",
                                    ]
                                    return colorList[params.dataIndex]
                                },
                            },
                        },
                        type: "bar",
                        showBackground: true,
                        backgroundStyle: {
                            color: "rgba(180, 180, 180, 0.2)",
                        },
                        barGap: "0",
                        label: {
                            normal: {
                                show: true,
                                formatter: "{c}",
                                align: "center",
                                position: "top",
                                distance: 10,
                                textStyle: {
                                    color: "#fff",
                                    fontSize: 14,
                                },
                            },
                        },
                    },
                ],
            }
            option && myChart.setOption(option)
        },
        // 入住老人能力评估
        getLodLiveEcharts() {
            this.chartFour = this.$echarts.init(this.$refs.lodLiveEcharts)
            // 编写echart参数
            let option = {
                grid: {
                    left: "20%",
                    right: "10%",
                    bottom: "22%",
                    top: "10%",
                    // containLabel: true,
                },
                xAxis: {
                    type: "category",
                    // boundaryGap: false,
                    data: ["自理", "半自理", "半失能", "失能"],
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: "#fff",
                        },
                    },
                },
                yAxis: {
                    type: "value",
                    // boundaryGap: [0, "50%"],

                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: "#fff",
                        },
                    },
                },
                series: [
                    {
                        name: "",
                        type: "bar",
                        barWidth: 33,
                        radius: ["60%", "50%"],
                        center: ["50%", "40%"],
                        data: [459, 210, 44, 30],
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    var colorList2 = [
                                        "#c63c26",
                                        "#65AC3A",
                                        "#36cfc9",
                                        "#AC03E2",
                                    ]
                                    return colorList2[params.dataIndex]
                                },
                            },
                        },
                    },
                ],
            }
            // 设置图表的参数
            this.chartFour.setOption(option)
        },
        // 能力评估
        getAbility() {
            const myChart = this.$echarts.init(this.$refs.ability)
            var option
            option = {
                // title: {
                //   subtext: "机构评级覆盖率", //副标题
                //   left: "15",
                //   subtextStyle: {
                //     //对应样式
                //     color: "#00D2FF",
                //     fontSize: 9,
                //   },
                // },
                tooltip: {
                    trigger: "item",
                },
                // legend:{
                //   show:true,
                //   left:"60%",
                //   height:"80%",
                //   orient:"vertical",
                //   align:"left",
                //   top:'20%',
                //   textStyle:{
                //     color:'#fff'
                //   }
                // },
                color: ["#0F5BF5", "#7FD42D", "#F21B62"],
                series: [
                    {
                        name: "能力评估",
                        type: "pie",
                        radius: "50%",
                        // radius: ['30%','50%'],
                        data: [
                            { value: 250, name: "市三级" },
                            { value: 250, name: "市一级" },
                            { value: 500, name: "其他" },
                        ],
                        label: {
                            show: true,
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            }
            option && myChart.setOption(option)
        },
        // 身体状况
        getBody() {
            const myChart = this.$echarts.init(this.$refs.body)
            var option
            var yData = []
            var total = 0
            this.oldInfo.medicalCareStatistics.forEach((item) => {
                total += item.countMedical
                yData.push({ value: item.countMedical, name: item.medical })
            })
            for (let i = 0; i < yData.length; i++) {
                yData[i].name =
                    yData[i].name +
                    ((yData[i].value / total) * 100).toFixed(2) +
                    "%"
            }
            option = {
                // title: {
                //   subtext: "养老机构医养结合覆盖率", //副标题
                //   left: "15",
                //   subtextStyle: {
                //     //对应样式
                //     color: "#00D2FF",
                //     fontSize: 9,
                //   },
                // },
                // tooltip: {
                //     trigger: "item",
                // },
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}:  ({d}%)",
                },
                color: ["#FFB026", "#D800FF"],
                series: [
                    {
                        name: "身体状况",
                        type: "pie",
                        radius: ["30%", "50%"],
                        // data: yData,
                        data: [
                            { value: 250, name: "医务室" },
                            { value: 250, name: "护理站" },
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            }
            option && myChart.setOption(option)
        },
        // 费用
        getCost() {
            const myChart = this.$echarts.init(this.$refs.cost)
            var option
            var yData = []
            var total = 0
            this.oldInfo.medicalCareStatistics.forEach((item) => {
                total += item.countMedical
                yData.push({ value: item.countMedical, name: item.medical })
            })
            for (let i = 0; i < yData.length; i++) {
                yData[i].name =
                    yData[i].name +
                    ((yData[i].value / total) * 100).toFixed(2) +
                    "%"
            }
            option = {
                color: ["#FFB026", "#D800FF"],
                series: [
                    {
                        name: "养老机构医养结合覆盖率",
                        type: "pie",
                        radius: ["30%", "50%"],
                        // data: yData,
                        data: [
                            { value: 250, name: "医务室：50%" },
                            { value: 250, name: "护理站：50%" },
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            }
            option && myChart.setOption(option)
        },
        // 机构评级覆盖率
        getOld() {
            const myChart = this.$echarts.init(
                document.getElementById("mechanism")
            )
            var option
            option = {
                title: {
                    subtext: "机构评级覆盖率", //副标题
                    left: "15",
                    subtextStyle: {
                        //对应样式
                        color: "#00D2FF",
                        fontSize: 10,
                    },
                },
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b} : {c} ({d}%)",
                },
                legend: {
                    right: "3%",
                    top: "8%",
                    textStyle: {
                        //图例文字的样式
                        color: "#fff",
                        fontSize: 16,
                    },
                },
                color: ["#0F5BF5", "#7FD42D", "#F21B62"],
                series: [
                    {
                        name: "机构评级覆盖率",
                        type: "pie",
                        // radius: "48%",
                        radius: ["35%", "50%"],
                        center: ["50%", "60%"],
                        data: [
                            { value: 12, name: "AAA" },
                            { value: 5, name: "AA" },
                            { value: 1, name: "A" },
                        ],
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true,
                                    formatter: "{b} :({d}%)",
                                },
                                labelLine: { show: true },
                            },
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            }
            option && myChart.setOption(option)
        },
        // 医养结合
        getCombination() {
            const myChart = this.$echarts.init(
                document.getElementById("combination")
            )
            var option
            option = {
                title: {
                    subtext: "养老机构医养结合覆盖率", //副标题
                    left: "15",
                    subtextStyle: {
                        //对应样式
                        color: "#fff",
                        fontSize: 16,
                    },
                },
                legend: {
                    top: "5%",
                    right: "8%",
                    textStyle: {
                        //图例文字的样式
                        color: "#fff",
                        fontSize: 16,
                    },
                },
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b} : {c} ({d}%)",
                },
                color: ["#FFB026", "#D800FF"],
                series: [
                    {
                        name: "养老机构医养结合覆盖率",
                        type: "pie",
                        radius: ["30%", "50%"],
                        center: ["50%", "50%"],
                        // data: yData,
                        data: [{ value: 12, name: "是" }],
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true,
                                    formatter: "{b} :({d}%)",
                                },
                                labelLine: { show: true },
                            },
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            }
            option && myChart.setOption(option)
        },
        // 获取社区区域图
        async getPolygon() {
            //机构管理
            // /rbac/admin/org/info/OrgTreelist
            // OrgTreelistVisualization
            const res = await this.$post(
                "/rbac/admin/org/info/OrgTreelistVisualization",
                {}
            )
            this.communityList2 = res.content[0].children
            this.markets()
            // this.showditu()

            res.content[0].children.forEach((item) => {
                let polygonArr = []

                if (item.pointPosition) {
                    item.pointPosition.split(",").forEach((e) => {
                        polygonArr.push(e.split(":"))
                    })
                    const polygon = new AMap.Polygon({
                        map: this.map,
                        path: polygonArr, //设置多边形边界路径
                        strokeColor: "#007CDB", //线颜色
                        strokeOpacity: 0.5, //线透明度
                        strokeWeight: 1, //线宽
                        fillColor: "#2191E6", //填充色
                        fillOpacity: 0.3, //填充透明度
                        extData: {
                            name: item.label,
                        },
                    })
                    polygon.id = item.orgId
                    polygon.address = item.label
                    //点击事件.
                    // polygon.projectId=polygonArr[item].id;
                    polygon.on("click", async (e) => {
                        // this.map.zoomIn();
                    })
                    //变色
                    polygon.on("mouseover", function () {
                        this.setOptions({
                            strokeOpacity: 1, //线透明度
                            strokeWeight: 2, //线宽
                            fillOpacity: 1, //填充透明度
                        })
                    })
                    polygon.on("mouseout", function () {
                        this.setOptions({
                            strokeOpacity: 0.5, //线透明度
                            strokeWeight: 1, //线宽
                            fillOpacity: 0.5, //填充透明度
                        })
                    })
                }
            })
        },
        // // 获取网格区域图
        // async getPolygon() {
        //   const res = await this.$post(
        //     "/ypt/admin/standardAddress/info/StandardAddressTree",
        //     { jiedaoId: "3201111" }
        //   );

        //   // console.log(res, "数据");
        //   res.content.forEach((item) => {
        //     let polygonArr = [];
        //     if (item.areaDivision) {
        //       item.areaDivision.split(",").forEach((e) => {
        //         polygonArr.push(e.split(":"));
        //       });
        //       console.log("坐标系", item.color);
        //       const polygon = new AMap.Polygon({
        //         map: this.map,
        //         path: polygonArr, //设置多边形边界路径
        //         strokeColor: "#1135D8", //线颜色
        //         strokeOpacity: 0.5, //线透明度
        //         strokeWeight: 1, //线宽
        //         fillColor: item.color, //填充色
        //         fillOpacity: 0.5, //填充透明度
        //         extData: {
        //           name: item.address,
        //         },
        //       });
        //       //点击事件
        //       polygon.on("click", function (e) {
        //         // that.$emit("setOrgId", item.id);
        //         // alert(111111111)
        //       });
        //       //变色
        //       polygon.on("mouseover", function () {
        //         this.setOptions({
        //           strokeOpacity: 1, //线透明度
        //           strokeWeight: 3, //线宽
        //           fillOpacity: 1, //填充透明度
        //         });
        //       });
        //       polygon.on("mouseout", function () {
        //         this.setOptions({
        //           strokeOpacity: 0.5, //线透明度
        //           strokeWeight: 1.5, //线宽
        //           fillOpacity: 0.5, //填充透明度
        //         });
        //       });
        //     }
        //   });
        // },
    },
    destroyed() {
        this.map && this.map.destroy()
    },
}
</script>

<style lang="less" scoped>
#container {
    position: absolute;
    left: 0;
    right: 0;
    top: 100px;
    bottom: 0;
    z-index: 1;
}
.box {
    color: #c4e2ff;
}
.box:hover {
    cursor: pointer;
    color: #fff;
}
.tableBox /deep/ .el-table--fit {
    // padding: 20px;
    // background-color: #01117b;
    color: #85c2ff;
    border: 1px solid #3573ad;
}
.tableBox /deep/ .el-table,
.el-table__expanded-cell .is-center {
    background-color: #01117b;
    color: #85c2ff;
    border: 1px solid #3573ad;
}

.tableBox /deep/ .el-table tr .is-center {
    background-color: #01117b !important;
    color: #85c2ff;
    border: 1px solid #3573ad;
}
.tableBox /deep/ .el-table--enable-row-transition .el-table__body td,
.el-table .cell .is-center {
    background-color: #01117b;
    color: #85c2ff;
    border: 1px solid #3573ad;
}

/deep/.amap-marker-label {
    border: none;
    font-size: 12px;
    color: #fff;
    margin-top: 5px;
    background: none;
    margin-left: -20px;
}
#ability {
    height: 100px;
    width: 200px;
}
#body {
    height: 100px;
    width: 200px;
}
#cost {
    height: 100px;
    width: 200px;
}
.mechanism_info {
    padding: 0;
    position: absolute;
    top: 20%;
    left: 20%;
    width: 60%;
    z-index: 999;
    background: rgba(10, 88, 160, 0.8);
    .mechanismName {
        height: 40px;
        background-color: #17378f;
        color: #fff;
        text-align: center;
        font-size: 20px;
        line-height: 40px;
    }
    .x {
        position: absolute;
        top: 5px;
        right: 13px;
        font-size: 22px;
        color: #fff;
        cursor: pointer;
    }
    .content1 {
        margin: 20px 20px 0;
    }
}

.content-info {
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
}

.content-info-item {
    width: 45%;
}
.main {
    background: url("./assets/big/data_bg.png") repeat;
    // overflow-x: hidden;
    width: 100%;
    .realTop {
        position: absolute;
        top: 0px;
        z-index: 2;
        background: url("./assets/big/oldTitle3.png");
        background-size: cover;
        margin: 0 auto;
        height: 90px;
        width: 100%;
    }
}
.oldBox {
    border: 1px solid rgba(34, 236, 255, 1);
    background: #01117b;
    margin-top: 28px;
    position: relative;
    min-height: 35px;
    .leftTitle {
        position: absolute;
        width: 100%;
        height: 35px;
        background: url("./assets/big/titleLeft.png") no-repeat center;
        text-align: center;
        font-size: 20px;
        line-height: 35px;
        color: #22f7ff;
        top: -17px;
        z-index: 200;
    }
}
.superLeft {
    position: absolute;
    top: 100px;
    left: 20px;
    width: 354px;
    bottom: 0px;
    z-index: 2;
    .superBox {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
    .chartTitle1 {
        padding-top: 15px;
    }
    .borderLine {
        background: linear-gradient(
            to right,
            rgba(41, 104, 232, 0),
            rgba(41, 104, 232, 1),
            rgba(41, 104, 232, 0)
        );
        height: 3px;
    }
    #beds {
        width: 100%;
        height: 36vh;
        margin-top: 20px;
    }
    #mechanism {
        margin-top: 10px;
        width: 100%;
        height: 24vh;
    }
    #combination {
        margin-top: 10px;
        width: 100%;
        height: 24vh;
    }
    .tip {
        color: #fff;
        text-align: center;
        font-size: 12px;
    }
    .tipUl {
        padding: 10px 15px;
        color: #fff;
        font-size: 13px;
        line-height: 22px;
        li {
            display: flex;
            .name {
                flex: 1;
            }
        }
    }
}

.superRight {
    position: absolute;
    top: 100px;
    right: 20px;
    width: 795px;
    bottom: 0;
    z-index: 2;
    .rightBox {
        display: flex;
        height: 100%;
        .rightChart {
            width: 280px;
            margin-right: 15px;
            position: relative;
            height: 100%;
            .jgBox {
                position: absolute;
                top: 0;
                height: 46vh;
                left: 0;
                right: 0;
            }
            .rzBox {
                position: absolute;
                bottom: 0;
                height: 36vh;
                left: 0;
                right: 0;
            }
            .heBox {
                height: 36vh;
            }
            .chartTitles {
                color: #00d2ff;
                font-size: 16px;
                padding-left: 15px;
                margin-top: 30px;
            }
            .chartBox {
                display: flex;
                flex-wrap: wrap;
                text-align: center;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
                padding: 10px;
                height: 40vh;
                overflow-y: auto;
                &::-webkit-scrollbar {
                    display: none; /* Chrome Safari */
                }
                .chartItem {
                    width: 50%;
                    margin-bottom: 20px;
                }
            }
            #huli {
                width: 100%;
                height: 18vh;
            }
            #lodLiveEcharts {
                width: 100%;
                height: 20vh;
            }
        }
        .rightTable {
            flex: 1;
            height: 100%;
            position: relative;
            .rzBoxs {
                position: absolute;
                top: 100px;
                height: 34vh;
                left: 0;
                right: 0;
            }
            .safeBox {
                position: absolute;
                bottom: 0;
                height: 36vh;
                left: 0;
                right: 0;
            }
            .mechanismNum {
                padding: 10px;
                height: 78px;
                border: 1px solid rgba(34, 236, 255, 1);
                background: #01117b;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #6483ff;
                font-size: 16px;
                .mechanismItem {
                    flex: 1;
                }
                .mechanismItem2 {
                    flex: 2;
                }
                .name {
                    color: #22f7ff;
                    font-size: 18px;
                    font-weight: bold;
                }
                .nums {
                    margin-top: 10px;
                    span {
                        color: #cb9537;
                        font-size: 26px;
                    }
                }
                .imgs {
                    width: 19px;
                    height: 19px;
                    margin-right: 6px;
                }
            }
            .houseBox {
                height: 100%;
                overflow: hidden;
                width: 500px;
                .houseList {
                    margin-top: 20px;

                    .houseBar {
                        line-height: 25px;
                        font-size: 13px;
                        color: #0090ff;
                        display: flex;
                        text-align: center;
                        padding-top: 15px;
                    }
                    .flexs {
                        display: flex;
                        p {
                            flex: 1;
                        }
                    }
                    .houseContent {
                        overflow: hidden;
                        margin-top: 10px;
                        height: 63vh;
                        .houseItem {
                            line-height: 25px;
                            font-size: 13px;
                            color: #e4e4e4;
                            display: flex;
                            text-align: center;
                            align-items: center;
                            background: rgba(255, 255, 255, 0.05);
                            margin-top: 25px;
                        }
                        .flexs {
                            display: flex;
                            p {
                                flex: 1;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }
                        }
                    }
                    .names {
                        width: 60px;
                    }
                    .ages {
                        width: 40px;
                    }
                    .sex {
                        width: 40px;
                    }
                    .times {
                        width: 80px;
                    }
                    .level {
                        width: 80px;
                        .color1 {
                            color: #7fd42d;
                        }
                        .color2 {
                            color: #ffb026;
                        }
                        .color3 {
                            color: #f21b62;
                        }
                        .color4 {
                            color: #d800ff;
                        }
                    }
                    .mechanisms {
                        flex: 1;
                    }
                }
            }
        }
    }
}

.party-map {
    width: 100%;
    /* height: calc(100vh - 20px); */
    height: 100vh;
    /* overflow: hidden; */
    /* overflow: hidden; */
    /* -webkit-box-shadow: inset 0 0 200px 150px #011729;
  box-shadow: inset 0 0 200px 150px #011729; */
}

@keyframes spin {
    50% {
        transform: translate(-50%, -101%) rotate(500deg);
    }
    100% {
        transform: translate(-50%, -101%) rotate(1000deg);
    }
}
.wave-progress {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background: #01117b;
    margin-left: -35px;
    overflow: hidden;
    position: relative;
    left: 50%;
}
.wave-progress1 {
    border: 2px solid #559715;
}
.wave-progress2 {
    border: 2px solid #ac1f4e;
}
.wave-progress3 {
    border: 2px solid #b98a37;
}
.wave-progress4 {
    border: 2px solid #990cb2;
}
.wave {
    position: relative;
    width: 100%;
    height: 100%;

    border-radius: 50%;
}
.wave1 {
    background-image: linear-gradient(-180deg, #7fd42d 13%, #7fd42d 100%);
}
.wave2 {
    background-image: linear-gradient(-180deg, #ac1f4e 13%, #ac1f4e 100%);
}
.wave3 {
    background-image: linear-gradient(-180deg, #b98a37 13%, #b98a37 100%);
}
.wave4 {
    background-image: linear-gradient(-180deg, #990cb2 13%, #990cb2 100%);
}
.waveNum {
    font-size: 16px;
    color: #fff;
    font-weight: bold;
    padding: 10px 0;
}
.waveTitle {
    font-size: 13px;
    line-height: 20px;
}
.waveTitle1 {
    color: #7fd42d;
}
.waveTitle2 {
    color: #ac1f4e;
}
.waveTitle3 {
    color: #b98a37;
}
.waveTitle4 {
    color: #990cb2;
}
.wave-mask {
    position: absolute;
    width: 200%;
    height: 200%;
    top: 0;
    left: 50%;
    border-radius: 40%;
    transform: translate(-50%, -101%) rotate(0);
    animation: spin 30s linear;
    z-index: 20;
    background-color: #01117b;
}
.num {
    position: absolute;
    width: 100%;
    height: 100%;
    color: #fff;
    font-size: 16px;
    line-height: 100px;
    font-weight: bold;
    text-align: center;
    z-index: 100;
}
/deep/.mapOpen {
    display: flex;
    width: 700px;
    .mapImg {
        width: 180px;
        height: 180px;
        margin-right: 12px;
    }
    .mapFlex {
        flex: 1;
        color: #474747;
        font-size: 30px;
        .address,
        .info {
            padding-top: 12px;
        }
    }
}
.bigdata_container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background-size: 100% 100%;
    // z-index: 100;
}
.quanp {
    position: absolute;
    top: 20px;
    right: 10px;
    z-index: 100;
    button {
        padding: 10px;
    }
}
.older-info {
    /deep/.el-dialog__header {
        background: #17378f;
        padding: 20px;
        .el-dialog__title {
            color: #fff;
        }
    }
    /deep/.el-dialog__body {
        background: #01117b;
        .el-form-item__label {
            color: #fff;
        }
        .el-input__inner {
            background-color: #01117b;
            border: 1px solid #17378f;
        }
    }
}
.border1 {
    border: 1px solid #22f7ff;
    margin-top: -1px;
    margin-left: -1px;
    padding: 10px;
}
.mechanism_info {
    /deep/.el-input__inner {
        background-color: #01117b;
        border: 1px solid #17378f;
        color: #fff;
    }
    /deep/.el-form-item__label {
        color: #fff;
    }
}
.monitor {
    position: absolute;
    top: 10px;
    right: 70px;
    font-size: 22px;
    color: #fff;
    cursor: pointer;
}
// ::-webkit-scrollbar{
//     display:?none;/*?Chrome?Safari?*/
// }
</style>
